import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var title = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_mjxy31',variantClassNames:{size:{xsmall:'fx_2d2fb1e5_mjxy32',small:'fx_2d2fb1e5_mjxy33','default':'fx_2d2fb1e5_mjxy34',large:'fx_2d2fb1e5_mjxy35'}},defaultVariants:{size:'default'},compoundVariants:[]});

export { title };
//# sourceMappingURL=title.vanilla.mjs.map
